import Vue from "vue";
import vueRouter from "vue-router";

import store from "@/store";

import SignUp from "./pages/SignUp";
import LogIn from "./pages/LogIn";
// import Dashboard from "./pages/Dashboard";
import UpdateUser from "./pages/UpdateUser";
import NotFound from "./pages/NotFound";
import Confirmation from "./pages/Confirmation";
// import Pricing from "./pages/Pricing";
// import Download from "./pages/Download";
import Profile from "./pages/Profile";
// import Contact from "./pages/Contact";
// import Guide from "./pages/Guide";
import Admin from "./pages/Admin";
import Report from "./pages/Report";
// import Service from "./pages/Service";
import OnGoingConfList from "./pages/OnGoingConfList";

import UserManagement from "./components/DashBoard/UserList";
import Room from "./components/DashBoard/RoomInfo";
import Calendar from "./components/DashBoard/SendMail";


import jwt from "jsonwebtoken";



// import { UserList } from "./components/DashBoard";

Vue.use(vueRouter);
const router = new vueRouter({
  //mode: "history",
  routes: [
    {
      path: "/",
      name: "Room Top",
      redirect: '/index',
      component: Room,
      meta: { onlyGuestUser: true, title: "VVCroom - Hội Nghị Truyền Hình" }
    },
    // {
    //   path: "/pricing",
    //   name: "Pricing",
    //   component: Pricing,
    //   meta: { onlyGuestUser: true, title: "Giá | VVCroom - Hội Nghị Truyền Hình" }
    // },
    // {
    //   path: "/service",
    //   name: "Service",
    //   component: Service,
    //   meta: { onlyGuestUser: true, title: "Dịch Vụ | VVCroom - Hội Nghị Truyền Hình" }
    // },

    // guide
    // {
    //   path: "/download",
    //   name: "Download",
    //   component: Download,
    //   meta: { onlyGuestUser: true, title: "Download" }
    // },
    // {
    //   path: "/contact",
    //   name: "Contact",
    //   component: Contact,
    //   meta: { onlyGuestUser: true, title: "Liên Hệ | VVCroom - Hội Nghị Truyền Hình" }
    // },
    // {
    //   path: "/guide",
    //   name: "Guide",
    //   component: Guide,
    //   meta: { onlyGuestUser: true, title: "Hướng Dẫn | VVCroom - Hội Nghị Truyền Hình" }
    // },
    {
      path: "/signup",
      name: "SignUp",
      component: SignUp,
      meta: { onlyGuestUser: true, title: "Đăng Ký | VVCroom - Hội Nghị Truyền Hình" }
    },
    {
      path: "/login",
      name: "LogIn",
      component: LogIn,
      meta: { onlyGuestUser: true, title: "Đăng Nhập | VVCroom - Hội Nghị Truyền Hình" }
    },
    {
      path: "/confirmation",
      name: "Confirmation",
      component: Confirmation,
      meta: { onlyGuestUser: true, title: "Confirmation" }
    },
    // {
    //   path: "/dashboard",
    //   name: "Dashboard",
    //   component: Dashboard,
    //   meta: {
    //     requiresAuth: true,
    //     title: "Quản Trị"
    //   }
    // },

    {
      path: "/user-management",
      name: "UserManagement",
      component: UserManagement,
      meta: {
        requiresAuth: true,
        title: "Quản lý người dùng"
      }
    },

    {
      path: "/index",
      name: "Room",
      component: Room,
      meta: {
        requiresAuth: true,
        title: "Quản lý phòng họp"
      }
    },

    {
      path: "/ongoing-conference-list",
      name: "OnGoingConfList",
      component: OnGoingConfList,
      meta: {
        requiresAuth: true,
        title: "Quản lý phòng họp"
      }
    },

    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        requiresAuth: true,
        title: "Tạo lịch họp"
      }
    },


    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        title: "Profile"
      }
    },
    {
      path: "/update",
      name: "UpdateUser",
      component: UpdateUser,
      meta: {
        requiresAuth: true,
        title: "UpdateUser"
      }
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        requiresAuth: true,
        title: "Admin"
      }
    },
    {
      path: "/report",
      name: "Report",
      component: Report,
      meta: {
        requiresAuth: true,
        title: "Report"
      }
    },
    {
      path: "/import",
      name: "Import",
      component: () => import("./components/Admin/Import"),
      meta: {
        requiresAuth: true,
        title: "Import"
      }
    },
    {
      path: "/room-management",
      name: "RoomAdmin",
      component: () => import("./components/Admin/Room"),
      meta: {
        requiresAuth: true,
        title: "Danh sách phòng họp"
      }
    },
    ,
    {
      path: "/party-management",
      name: "PartyManagement",
      component: () => import("./components/Admin/PartyManagement"),
      meta: {
        requiresAuth: true,
        title: "Danh sách người dùng"
      }
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
      meta: { title: "Page Not Found" }
    },
    {
      path: "/user/:username",
      name: "manageUser",
      component: () => import("./components/Admin/Participants"),
      meta: { title: "Participant Management", requiresAuth: true }
    },

    {
      path: "/dkkh",
      name: "SignUpByAdmin",
      component: () => import("./pages/SignUpByAdmin"),
      meta: {
        requiresAuth: true,
        title: "Đăng Ký | VVCroom - Hội Nghị Truyền Hình"
      }
    },

    {
      path: "/locked-parties",
      name: "LockedUsers",
      component: () => import("./components/Admin/LockedRMParties"),
      meta: { title: "Danh sách user RM bị khoá", requiresAuth: true }
    },

    {
      path: "/ongoing-conference",
      name: "OnGoingConference",
      component: () => import("./pages/OnGoingConference"),
      meta: {
        requiresAuth: true,
        title: "Cuộc họp"
      },
      props: route => ({ roomID_MCU: route.query.roomID_MCU, confId: route.query.confId })
    },

    {
      path: "/conversation",
      name: "Conversation",
      component: () => import("./components/Conversation/Participant"),
      meta: { title: "Conversation", requiresAuthParticipant: true }
    },
    {
      path: "/passcode-room-management",
      name: "OTPRoomOrder",
      component: () => import("./pages/PassCodeRoomOrder"),
      meta: {
        title: 'Lọc người tham gia phòng họp',
        requiresAuth: true
      }
    },
  ]
});
router.beforeEach((to, from, next) => {

  document.title = to.meta.title;

  if(!store.getters["auth/isLoggedIn"]) {
    localStorage.removeItem("usertoken");
    localStorage.removeItem("username");
    localStorage.removeItem("entityTag");
    localStorage.removeItem("conferenceId");
    localStorage.removeItem("roomId");
    localStorage.removeItem("bookedParties");
    localStorage.removeItem("exclusiveContentJointParticipants");
    localStorage.removeItem("partyLayoutJointParticipants");
  }

  if(!store.getters["authParticipant/isLoggedIn"]) {
    localStorage.removeItem("participantToken");
    localStorage.removeItem("participant");
    localStorage.removeItem("participantHost");
    localStorage.removeItem("participantName");
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters["auth/isLoggedIn"]) {
      next();
      const adminPage = ["Admin", "manageUser", "Import", "Report", "SignUpByAdmin", "RoomAdmin", "LockedUsers", 'PartyManagement'];
      if (adminPage.includes(to.name)) {
        const token = store.state.auth.token;
        const decodedToken = jwt.decode(token);

        if (decodedToken.type !== 1) {
          next("NotFound");
        }
      }

      return;
    }
    next("/login");
  }
  else if (to.matched.some(record => record.meta.requiresAuthParticipant)) {

    if (store.getters["authParticipant/isLoggedIn"]) {
      next();

      return;
    }
    next("/login");
  }

  else {
    // check if Logged the router go back to current Page or Login page
    if (to.name === "LogIn" && store.getters["auth/isLoggedIn"]) {
      next(from.name);
      return;
    }
    else if (to.name === "LogIn" && store.getters["authParticipant/isLoggedIn"]) {
      next('/conversation');
      return;
    }
    next();
  }


});

export default router;
